import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { EyeIcon, MicIcon } from 'lucide-react';
export function RoleSelect() {
  const navigate = useNavigate();
  const goRegister = (role: 'viewer' | 'comedian') => {
    navigate(`/auth/register?role=${role}`);
  };
  return <div className="w-full h-full bg-black relative overflow-hidden flex flex-col" data-id="element-314">
      {/* Background Photo */}
      <div className="absolute inset-0" data-id="element-315">
        <motion.img initial={{
        scale: 1.15
      }} animate={{
        scale: 1
      }} transition={{
        duration: 8,
        ease: 'easeOut'
      }} src="https://cdn.magicpatterns.com/uploads/sRLbawZodLUc18DA8Lnh1s/ChatGPT_Image_May_12,_2026,_08_33_20_PM.png" alt="Multicultural group of people with happy faces" className="absolute inset-0 w-full h-full object-cover" data-id="element-316" />

        {/* Overlays for legibility */}
        <div className="absolute inset-0 bg-black/45" data-id="element-317" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-black" data-id="element-318" />

        {/* Yellow stage glow */}
        <motion.div animate={{
        opacity: [0.3, 0.5, 0.3]
      }} transition={{
        duration: 6,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute -top-20 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-primary/15 rounded-full blur-3xl" data-id="element-319" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex-1 flex flex-col px-6 pb-8" data-id="element-320">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="flex-1 flex flex-col items-center justify-center text-center" data-id="element-321">
          {/* Icon */}
          <div className="w-16 h-16 rounded-2xl bg-primary/20 border border-primary/40 flex items-center justify-center mb-6 backdrop-blur-sm" data-id="element-322">
            <span className="text-4xl" data-id="element-323">🎭</span>
          </div>

          <h1 className="text-3xl font-poppins font-extrabold text-white mb-3 leading-tight drop-shadow-lg" data-id="element-324">
            Join the Haus
          </h1>
          <p className="text-white/80 text-sm max-w-xs leading-relaxed drop-shadow-md" data-id="element-325">
            Tell us how you'll be having fun. You can switch this up later.
          </p>
        </motion.div>

        {/* Actions */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.15
      }} className="flex flex-col gap-3" data-id="element-326">
          <button onClick={() => goRegister('viewer')} className="w-full bg-white/10 hover:bg-white/15 border border-white/40 rounded-2xl py-4 flex items-center justify-center gap-3 text-white font-bold transition-colors backdrop-blur-md" data-id="element-327">
            <EyeIcon size={20} data-id="element-328" />
            Sign up as a Viewer
          </button>

          <button onClick={() => goRegister('comedian')} className="w-full bg-primary hover:bg-primary/90 rounded-2xl py-4 flex items-center justify-center gap-3 text-[#121212] font-bold transition-colors shadow-[0_4px_20px_rgba(255,212,0,0.3)]" data-id="element-329">
            <MicIcon size={20} data-id="element-330" />
            Sign up as a Comedian
          </button>

          <button onClick={() => navigate('/feed')} className="w-full bg-transparent border border-white/25 hover:border-white/40 rounded-2xl py-4 text-white font-medium transition-colors backdrop-blur-sm" data-id="element-331">
            Continue as Guest
          </button>

          <p className="text-center text-sm text-white/70 mt-4 drop-shadow" data-id="element-332">
            I already have an account{' '}
            <button onClick={() => navigate('/auth/login')} className="text-white font-bold hover:text-primary transition-colors" data-id="element-333">
              Login
            </button>
          </p>
        </motion.div>
      </div>
    </div>;
}